import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { BusSeatMap } from './ui/bus_seat_map.js';

/**
 * Entrada de catálogo do `bus_seat_map` (slot chat). Interativo: a escolha da
 * poltrona volta por `interaction` (challengeId + `{ seatCode }` opaco) — o
 * componente monta a action; o shell é só transporte.
 */
export const busSeatMapEntry: GenUiEntry<Extract<ChatUi, { kind: 'bus_seat_map' }>> = {
  kind: 'bus_seat_map',
  slot: 'chat',
  policy: { productOf: () => 'bus' },
  render: ({ ui, note, readOnly, dispatch }) => (
    <BusSeatMap ui={ui} note={note} readOnly={readOnly} dispatch={dispatch} />
  ),
};
